const ITEMS = ["Private Property Impound", "Parking Enforcement", "Pay 2 Park", "Property Manager App", "Abandoned Vehicles", "Towing", "Recovery", "Charlotte, North Carolina"];

const Star = () => (
  <svg viewBox="0 0 24 24" className="mx-8 h-6 w-6 shrink-0 sm:mx-12 sm:h-8 sm:w-8" aria-hidden="true">
    <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" fill="#74A636" />
  </svg>
);

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="whitespace-nowrap font-display text-5xl font-extrabold uppercase italic tracking-tight sm:text-7xl lg:text-8xl">{t}</span>
        <Star />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee-section" className="relative border-y border-[var(--line)] py-8 sm:py-10" aria-label="Services">
    <div className="flex overflow-hidden">
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  </section>
);
